import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { AssetRegisterCategoryContainerModel } from '../../../../../../models/aggregates/erp/asset-register/asset-register-category-container.model'
@Injectable({
  providedIn: 'root'
})
export class AssetRegisterCategoryService extends BaseApiTemplateService<AssetRegisterCategoryContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + 'fa/fixed-asset-registers/categories/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + 'fa/fixed-asset-registers/categories/backoffice-ep';;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + 'fa/fixed-asset-registers/categories/backoffice-ep';
    this.httpClient = http;
  }

}
